import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllPostsForAdmin, deletePost, publishPost, unpublishPost } from '../utils/blogService';
import './BlogAdmin.css';

function formatDate(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('ru-RU', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch (_) {
    return '—';
  }
}

export default function BlogAdmin() {
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const data = await getAllPostsForAdmin();
      setPosts(data);
      setError('');
    } catch (e) {
      console.error('Error loading posts:', e);
      setError('Не удалось загрузить посты.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleTogglePublish = async (post) => {
    setBusyId(post.id);
    try {
      if (post.status === 'published') {
        await unpublishPost(post.id);
      } else {
        await publishPost(post.id);
      }
      await load();
    } catch (e) {
      console.error('Error toggling publish state:', e);
      alert('Не удалось изменить статус поста.');
    } finally {
      setBusyId(null);
    }
  };

  const handleDelete = async (post) => {
    if (!window.confirm(`Удалить пост «${post.title}»? Это действие нельзя отменить.`)) return;
    setBusyId(post.id);
    try {
      await deletePost(post.id);
      await load();
    } catch (e) {
      console.error('Error deleting post:', e);
      alert('Не удалось удалить пост.');
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className="blog-admin-page">
      <div className="blog-admin-header">
        <h1>Блог</h1>
        <button className="blog-btn blog-btn-primary" onClick={() => navigate('/blog/admin/new')}>
          + Новый пост
        </button>
      </div>

      {error && <div className="blog-post-editor-error">{error}</div>}

      {loading ? (
        <p className="blog-admin-empty">Загрузка…</p>
      ) : posts.length === 0 ? (
        <div className="blog-admin-empty-state">
          <p>Постов пока нет.</p>
          <button className="blog-btn blog-btn-secondary" onClick={() => navigate('/blog/admin/new')}>
            Написать первый пост
          </button>
        </div>
      ) : (
        <div className="blog-admin-list">
          {posts.map((post) => (
            <div key={post.id} className="blog-admin-row">
              <div className="blog-admin-row-main">
                <div className="blog-admin-row-title-line">
                  <span className="blog-admin-row-title">{post.title || '(без заголовка)'}</span>
                  <span className={`blog-admin-status blog-admin-status-${post.status}`}>
                    {post.status === 'published' ? 'Опубликован' : 'Черновик'}
                  </span>
                </div>
                <div className="blog-admin-row-meta">
                  Обновлён {formatDate(post.updatedAt)}
                  {post.status === 'published' && <> · опубликован {formatDate(post.publishedAt)}</>}
                </div>
              </div>
              <div className="blog-admin-row-actions">
                <button
                  className="blog-btn blog-btn-ghost"
                  disabled={busyId === post.id}
                  onClick={() => navigate(`/blog/admin/${post.id}/edit`)}
                >
                  Редактировать
                </button>
                <button
                  className="blog-btn blog-btn-secondary"
                  disabled={busyId === post.id}
                  onClick={() => handleTogglePublish(post)}
                >
                  {post.status === 'published' ? 'Снять с публикации' : 'Опубликовать'}
                </button>
                <button
                  className="blog-btn blog-btn-danger"
                  disabled={busyId === post.id}
                  onClick={() => handleDelete(post)}
                >
                  Удалить
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
